// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationAR from './locales/ar/translation.json';

i18n
  .use(LanguageDetector) // 👈 Enable browser + localStorage detection
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: {
      en: { translation: translationEN },
      ar: { translation: translationAR }
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng', // 👈 Key used to store language
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
